import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const MultiCategoryHomepageRBAC = {
  pageID: '541067e73fc0d3e01c8944f01a03061c',
  elementID: {
    Create: '8bfff662a29e3b92664f0bc0798c3b10',
    Edit: '5410c78eac1dafe053ae3afdd49e9480',
    Delete: '3d40a5ba5a9e3b92664ef876ccfd7785',
    View: '54108379891dafe053ae3afdb8b4ceb7',
    AturPosisi: 'fe35878cda11ed82a050d6cd777f1d31',
  },
} as const

export const useRBACMultiCategoryHomepage = createUseRBAC(MultiCategoryHomepageRBAC.elementID)

export type UseRBACMultiCategoryHomepageType = ReturnType<typeof useRBACMultiCategoryHomepage>
